module.exports = __webpack_public_path__ + "img/media_liabary_main.ee4decb5.jpg";